<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button, RadioGroup, Radio } from "view-design";
import SignIn from "./signIn.vue";
import config from "@/../config";
import dayjs from "dayjs";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "",
        key: "id",
        url: {
          list: "/admin/system/meeting/list",
        },
        output: false,
      },
      menus: [
        {
          label: "我的会议",
          name: "MyMeeting",
          auth: "system/MyMeeting/index",
        },
        {
          label: "所有会议",
          name: "MeetingList",
          auth: "system/MeetingList/index",
        },
      ],
      actions: [],
      filters: [
        {
          label: "开始时间",
          KeyEnter: this.search,
          name: "meetingStateTime",
          value: "",
          type: "contractdatetimerange",
        },
        {
          label: "会议室",
          KeyEnter: this.search,
          name: "meetingLocationName",
          value: "",
          type: "input",
        },
        {
          label: "主题",
          KeyEnter: this.search,
          name: "meetingtTitle",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "主题/参会人",
          minWidth: 350,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            let names;
            let userList = row.sysUserList;
            if (userList) {
              names = userList.map((obj) => obj.nickName).join(", ");
            }
            return (
              <div>
                <p
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => this.toClaim(row)}
                >
                  {row.meetingtTitle}
                </p>
                <p>参会人: {names}</p>
              </div>
            );
          },
        },
        {
          title: "会议室",
          minWidth: 80,
          align: "left",
          key: "meetingLocationName",
        },
        {
          title: "开始时间",
          width: 160,
          align: "left",
          key: "meetingStateTime",
        },
        {
          title: "时长",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row.meetingDuration;
            const text =
              row == "1"
                ? "30分钟"
                : row === "2"
                ? "1小时"
                : row === "3"
                ? "1.5小时"
                : row === "4"
                ? "2小时"
                : row === "5"
                ? "2.5小时"
                : row === "6"
                ? "3小时"
                : row === "7"
                ? "3.5小时"
                : row === "8"
                ? "4小时"
                : row === "9"
                ? "4.5小时"
                : row === "10"
                ? "5小时"
                : row === "11"
                ? "5.5小时"
                : row === "12"
                ? "6小时"
                : row === "13"
                ? "6.5小时"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "签到时间",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row.meetingCheckDuration;
            const text =
              row == "1"
                ? "开始前15分钟"
                : row === "2"
                ? "开始前20分钟"
                : row === "3"
                ? "开始前30分钟"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "发起人",
          width: 100,
          align: "center",
          key: "principalName",
        },
        {
          title: "状态",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row.type;
            const text =
              row == 1
                ? "未开始"
                : row === 2
                ? "签到中"
                : row === 3
                ? "进行中"
                : row === 4
                ? "已结束"
                : row === 5
                ? "审核中"
                : row === 6
                ? "审核拒绝"
                : row === 7
                ? "已取消"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "拒绝理由",
          minWidth: 80,
          align: "center",
          key: "rejectContent",
        },
        {
          title: "操作",
          align: "center",
          width: 170,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <div>
                  <Button
                    vShow={
                      currentRow.type == 5 || currentRow.type == 6 || currentRow.type == 7
                        ? false
                        : true
                    }
                    size="small"
                    onClick={() => this.toInfo(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "5px",
                    }}
                  >
                    会议记录
                  </Button>
                  <Button
                    size="small"
                    onClick={() => this.delItem(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                    }}
                  >
                    删除
                  </Button>
                </div>
              );
            },
          ],
        },
      ],
    };
  },
  created() {},
  methods: {
    toInfo(Row) {
      $utils.url.push({ name: "meetingInfo", query: { id: Row.meetingId } });
    },
    toClaim(Row) {
      $utils.api.load(`/admin/system/meeting/${Row.meetingId}`, {}).then((res) => {
        if (res && res.data) {
          let type = res.data.type;
          if (type == 5) {
            $utils.toast.success("会议审核中,请稍后!");
          } else if (type == 7) {
            $utils.toast.success("会议已取消!");
          } else {
            this.$Modal.success({
              closable: true,
              width: "1300px",
              height: "80px",
              okText: "取消",
              showOk: false,
              render: (h) => {
                return (
                  <div>
                    <SignIn
                      onOnCancel={() => {
                        this.onCancel();
                      }}
                      id={Row.meetingId}
                    />
                  </div>
                );
              },
            });
          }
        }
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(
        `/admin/system/meeting/${row.meetingId}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.search();
        }, 100);
      }
    },
  },
};
</script>

<style></style>
